/**
 * Lead capture form card — message factory és mező inicializálás.
 */

/**
 * @param {{ form_id: string, form_payload: object, source_message_id?: string|number|null }} event
 */
export function createLeadFormMessage(event) {
    const payload = event.form_payload ?? {};
    const fieldValues = initFieldValues(payload);

    return {
        role: 'lead_form',
        id: event.source_message_id ?? null,
        formId: event.form_id,
        payload,
        fieldValues,
        hasPrefill: Object.values(fieldValues).some((value) => String(value ?? '').trim() !== ''),
        consentGiven: false,
        state: 'open',
        errorMessage: null,
        successMessage: payload.success_message ?? null,
        successUrl: null,
        successUrlLabel: null,
    };
}

/**
 * A prefill a beszélgetésből előkészített, szerkeszthető javaslat — csak leíró mezőkre jön.
 *
 * @param {{ fields?: Array<{ id: string }>, prefill?: Record<string, string> }} payload
 */
export function initFieldValues(payload) {
    const values = {};
    const prefill = payload.prefill ?? {};

    for (const field of payload.fields ?? []) {
        if (field?.id) {
            const suggested = prefill[field.id];
            values[field.id] = typeof suggested === 'string' ? suggested : '';
        }
    }

    return values;
}

/**
 * @param {{ payload?: { fields?: Array<{ id: string, required?: boolean }> }, fieldValues?: Record<string, string>, consentGiven?: boolean }} msg
 */
export function canSubmitLeadForm(msg) {
    if (msg.payload?.consent_required !== false && ! msg.consentGiven) {
        return false;
    }

    for (const field of msg.payload?.fields ?? []) {
        if (field.required && ! String(msg.fieldValues?.[field.id] ?? '').trim()) {
            return false;
        }
    }

    return true;
}
